import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

interface ShopBannerProps {
  seller: any;
  userId: string;
  top100?: boolean; // Optional prop to indicate if it's a Top 100 banner
  comics?: boolean; // Optional prop to indicate if it's a Comics banner
}

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
`;

export default function ShopBanner({
  seller,
  userId,
  top100 = false, // Default to false if not provided
  comics = false,
}: ShopBannerProps): JSX.Element {
  const [error, setError] = useState("");
  const params = useParams<any>();
  const location = useLocation();
  const [sellerId, setSellerId] = useState<string>(params?.id); // Add state for sellerId
  const dispatch = useDispatch();
  useEffect(() => {
    console.log("ShopBanner sellerId:", sellerId);
    const newSellerId =
      params?.id || seller.sellerId || location.pathname.split("/")[2];
    setSellerId(newSellerId);
  }, [params]);

  const renderContent = () => {
    const Seller_Shop_Name = seller?.shopName || seller?.firstName || "";
    if (sellerId === "0" || !sellerId) {
      return <div>No seller information available</div>;
    }

    if (top100) {
      return (
        <div className="shopBannerImage">
          <img
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "500px",
              objectFit: "fill",
            }}
            src="https://storage.googleapis.com/content.paysfer.com/banner/Top100Books_Banner.jpeg"
            alt="Top 100 Banner"
          />
        </div>
      );
    }
    if (comics) {
      return (
        <div className="shopBannerImage">
          <img
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "500px",
              objectFit: "fill",
            }}
            src="https://storage.googleapis.com/content.paysfer.com/banner/comicsstore_banner.png"
            alt="Comics Banner"
          />
        </div>
      );
    }
    if (sellerId === "29658816") {
      return (
        <div className="shopBannerImage">
          <img
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "400px",
              objectFit: "fill",
            }}
            src="https://storage.googleapis.com/content.paysfer.com/banner/anyco_banner.webp"
            alt="Seller Image"
          />
        </div>
      );
    } else if (sellerId === "0592de2a-815c-4929-a521-82301b246cce") {
      return (
        <div className="shopBannerImage">
          <img
            className="shopBannerImageBookShop"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "500px",
              objectFit: "fill",
              marginTop: "-5px",
            }}
            src="https://storage.googleapis.com/content.paysfer.com/banner/bookshop-banner.jpg"
            alt="Seller Image"
          />
        </div>
      );
    } else if (sellerId === "40551232") {
      return (
        <div className="shopBannerImage">
          <img
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "350px",
              objectFit: "fill",
            }}
            src="https://storage.googleapis.com/content.paysfer.com/banner/updated_banners/RJ_BULLION_BANNER.jpg"
            alt="Seller Image"
          />
        </div>
      );
    } else if (sellerId === "81418180") {
      return (
        <div className="shopBannerImage">
          <img
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "400px",
              objectFit: "fill",
            }}
            src="https://storage.googleapis.com/content.paysfer.com/banner/Kalustyans_Banner.webp"
            alt="Seller Image"
          />
        </div>
      );
    } else {
      return (
        <div className="shopDetailsHeader">
          <h3>{Seller_Shop_Name.toUpperCase()}</h3>
        </div>
      );
    }
  };

  return (
    <div className="shopBannerContainer">
      {renderContent()}

      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
}
